
<div class="flex column center errorImage gap-40">
	<img src="{{image ? image : 'assets/images/not-results-found.png'}}"
		alt="{{(image ? 'general.empty-state' : 'general.not-results-found') | translateWithKeys}}">
	<div class="flex column gap-8 center">
		<div>
			<h4 class="title" *ngIf="title; else noTitle">
				{{ title | translateWithKeys: ( { params: { item: dynamicText | translateWithKeys} }) }}
			  </h4>
		
			<ng-template #noTitle>
				<h4 class="title">{{ 'general.not_results_found' | translateWithKeys: (dynamicText ? { params: { item: dynamicText } } : {}) }}</h4>
			</ng-template>
			  
		</div>
		<span class="body2">{{(text ? text : 'general.not_results_found_description') | translateWithKeys}}</span>
	</div>
</div>
